import type { FC, ReactNode, Dispatch, SetStateAction } from "react";
import { createContext, useState } from "react";

enum GlobalContextUserRole {
  CLERK = "clerk",
  PATIENT = "patient",
  PRACTITIONER = "practitioner",
  ROLELESS = "roleless",
  UNAUTHENTICATED = "unauthenticated",
}
interface GlobalContextType {
  adminImpersonating?: boolean;
  country: string;
  role: GlobalContextUserRole;
  setRole?: Dispatch<SetStateAction<GlobalContextUserRole>>;
  isFromWellevate?: boolean;
  isFromEmersonEcologics?: boolean;
  e2e: boolean;
  iterableApiKey?: string;
}

const GlobalContextDefault: GlobalContextType = {
  adminImpersonating: false,
  country: "United States",
  role: GlobalContextUserRole.UNAUTHENTICATED,
  isFromWellevate: false,
  isFromEmersonEcologics: false,
  e2e: false,
};

const GlobalContext = createContext<GlobalContextType>(GlobalContextDefault);

interface Props {
  adminImpersonating?: boolean;
  country: string;
  role: GlobalContextUserRole;
  isFromWellevate?: boolean;
  isFromEmersonEcologics?: boolean;
  e2e: boolean;
  children: ReactNode;
  iterableApiKey?: string;
}

const GlobalContextProvider: FC<Props> = ({
  children,
  adminImpersonating,
  role,
  country,
  isFromWellevate,
  isFromEmersonEcologics,
  e2e,
  iterableApiKey,
}) => {
  const [stateRole, setRole] = useState(role);

  return (
    <GlobalContext.Provider
      value={{
        country,
        adminImpersonating,
        role: stateRole,
        setRole,
        isFromWellevate,
        isFromEmersonEcologics,
        e2e,
        iterableApiKey,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};

export { GlobalContext, GlobalContextUserRole, GlobalContextProvider, GlobalContextDefault };
export type { GlobalContextType };
